import * as Consts from "../../ts/rlAdmin.consts";
import * as Models from "../../ts/rlAdmin.models";
import { AdminConfigService } from "../../services/admin-config-service";
import { NotifyService } from "../../services/notify-service";

export class CatalogSettingsConfigController {
	static $inject = ["$scope", "adminConfigService", "notifyService"];

	divSettings: _.Dictionary<Models.IDivSetting> = {};
	divSettingEnabled: _.Dictionary<boolean> = {};

	autoSyncDivSettingKey = Consts.DivSettingKey.AutoSyncDealCatalogRights
	catalogMetaSyncDeleteIfNullSettingKey = Consts.DivSettingKey.CatalogMetaSyncDeleteIfNull;

	constructor(private $scope: ng.IScope, private adminConfigService: AdminConfigService, private notifyService: NotifyService) {

	}

	Init() {
		this.notifyService.startProgress();
		this.adminConfigService.getDivSettingList().then(settings => {
			this.notifyService.endProgress();
			if (_.isArray(settings)) {
				[this.autoSyncDivSettingKey, this.catalogMetaSyncDeleteIfNullSettingKey]
					.forEach(
						(settingsKey) => {
							this.divSettings[settingsKey] = _.find(settings, x => x.key === settingsKey);
							this.divSettingEnabled[settingsKey] = this.divSettings[settingsKey] && this.divSettings[settingsKey].value === "True";
						}
					);
			}
		});
	}

	UpdateCatalogSetting(settingsKey:string) {
		var setting = this.divSettings[settingsKey];
		
		var promise = setting
			? this.UpdateDivSetting(setting)
			: this.CreateNewDivSetting(settingsKey);

		promise.then(x => {
			this.notifyService.notifySuccess('Setting Updated');
		}).catch(x => {
			this.notifyService.notifyError('Setting Update Failed');
		}).finally(() => {
			this.Init();
		});
	}

	CreateNewDivSetting(key: string) {
		const setting: Models.IDivSetting = {
			divSettingID: null,
			key: key,
			value: 'True'
		};
		return this.adminConfigService.createDivSetting(setting);
	}

	UpdateDivSetting(setting: Models.IDivSetting) {
		setting.value = setting.value === 'False' ? 'True' : 'False';
		return this.adminConfigService.updateDivSetting(setting);
	}
}